import { useRef, useState, useEffect, useCallback, useLayoutEffect } from "react";
import { getAddressInfo } from "../../getAddressInfo.js";
import { useGoogleLoader } from "../GoogleLoaderProvider.js";
import "react/jsx-runtime";
import "../../../components/Button/Button.js";
import "../../../components/InputControl/InputControl.js";
import "../../../components/InputControl/Input/InputBase.js";
import "../../../components/PhoneInputControl/PhoneInputControl.js";
import "../../../components/PhoneInputControl/PhoneInput/PhoneInput.js";
import "../../../components/IconButton/IconButton.js";
import "../../../components/common/ControlBody.js";
import "@mui/material";
import "../../../components/SelectControl/Select/context/SelectContext.js";
import "../../../components/Dialog/Dialog.js";
import "../../../components/IconButtonNew/IconButton.js";
import "../../../icons/24/Action/Close.js";
import "../../../icons/24/Arrow/ChevronLeft.js";
import "../../../components/SelectControl/Select/components/SelectInput/SelectInput.js";
import "../../../components/SelectControl/Select/MultiSelect/context/MultiSelectContext.js";
import "../../../icons/24/System/Check.js";
import "../../../icons/24/Arrow/ChevronDown.js";
import "../../../components/TextareaControl/TextareaControl.js";
import "../../../components/SearchControl/SearchControl.js";
import "../../../icons/24/System/Search.js";
import "../../../components/FormattedPhone/FormattedPhoneNumber.js";
import "../../../components/Avatar/styles.js";
import "../../../components/CheckboxGroup/Checkbox/styles.js";
import "../../../components/CheckboxGroup/styles.js";
import "../../../components/RadioGroup/Radio/styles.js";
import "../../../components/RadioGroup/styles.js";
import "../../../components/RatingButton/styles.js";
import "../../../components/FloatingActionButton/styles.js";
import "../../../components/SortingButton/styles.js";
import "../../../components/SquareButton/styles.js";
import "../../../components/Toggle/styles.js";
import "../../../components/Dialog/StyledDialog.js";
import "../../../components/Chips/Chip/styles.js";
import "../../../components/ResultMarksNumber/styles.js";
import "../../../components/Progress/ProgressCircle/styles.js";
import "../../../components/Loaders/LoaderCircle/styles.js";
import "../../../components/Loaders/LoaderLine/styles.js";
import "../../../components/SegmentedControl/styles.js";
import "../../../components/ResultMarksText/styles.js";
import "../../../components/Link/styles.js";
import "../../../components/Tag/Tag.js";
import "../../../components/DatePicker/constants.js";
import "../../../components/DatePicker/components/RangePicker/context/DateRangePickerContext.js";
import "../../../components/DatePicker/components/RangePicker/context/DateRangePickerContextActions.js";
import "../../../components/DatePicker/shared/fragments/CalendarCell/CalendarCell.js";
import "../../../external/classnames/index.js";
import "../../../components/Scrollbar/Scrollbar.js";
import "../../../components/DatePicker/shared/fragments/MonthYearSelector/YearSelector.js";
import "../../../components/DatePicker/components/DatePicker/context/DatePickerContext.js";
import "../../../components/DatePicker/components/DatePicker/context/DatePickerContextActions.js";
import "../../../components/MobileBottomSheet/MobileBottomSheet.js";
import "../../../components/List/ListItem/ListItem.js";
import "../../../components/Nowrap.js";
import "../../../components/List/ListItemTree/TreeListItem.js";
import "../../../components/List/ListItemTree/components/Label.js";
import { redDefaultMarker } from "./b64Images.js";
const defaultCoords = { lat: 39.8097343, lng: -98.5556199 }, defaultMapSettings = {
  center: defaultCoords,
  zoom: 4
}, useGoogleMap = ({
  zoom = defaultMapSettings.zoom,
  center = defaultMapSettings.center,
  googlePlace,
  marker: markerImage
} = defaultMapSettings) => {
  const ref = useRef(null), refInfoWindow = useRef(null), loader = useGoogleLoader(), [state, setState] = useState({}), [tooltip, setTooltipInfo] = useState({ header: "", info: "" });
  useEffect(() => {
    let map;
    return loader == null || loader.importLibrary("maps").then(({ Map, InfoWindow }) => {
      if (!ref.current)
        return;
      map = new Map(ref.current, {
        center: { lat: center == null ? void 0 : center.lat, lng: center == null ? void 0 : center.lng },
        streetViewControl: !1,
        mapTypeControl: !1,
        zoom
      }), map.addListener("click", async (e) => {
        e.latLng;
      });
      const marker2 = new google.maps.Marker({
        map,
        icon: markerImage ?? redDefaultMarker,
        anchorPoint: new google.maps.Point(0, -29)
      });
      marker2.setVisible(!1);
      let infoWindow2;
      refInfoWindow.current && (infoWindow2 = new InfoWindow(), infoWindow2.setContent(refInfoWindow.current)), marker2.addListener("click", () => {
        infoWindow2 == null || infoWindow2.open(map, marker2), refInfoWindow.current && (refInfoWindow.current.style.display = "block");
      }), setState({ map, infoWindow: infoWindow2, marker: marker2 });
    }), () => {
      setState({}), map && (map.unbindAll(), google.maps.event.clearInstanceListeners(map));
    };
  }, [center == null ? void 0 : center.lat, center == null ? void 0 : center.lng, loader, markerImage, zoom]);
  const { marker, infoWindow } = state;
  useEffect(() => {
    marker && infoWindow && googlePlace && (infoWindow.open(null, marker), refInfoWindow.current && (refInfoWindow.current.style.display = "block"));
  }, [googlePlace, infoWindow, marker]);
  const setMapPlace = useCallback(
    (place) => {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      if ((_a = state.infoWindow) == null || _a.close(), refInfoWindow.current && (refInfoWindow.current.style.display = "none"), (_b = state.marker) == null || _b.setVisible(!1), !((_c = place.geometry) != null && _c.location)) {
        console.error("No details available for input: '" + place.name + "'");
        return;
      }
      place.geometry.viewport ? (_d = state.map) == null || _d.fitBounds(place.geometry.viewport) : ((_e = state.map) == null || _e.setCenter(place.geometry.location), (_f = state.map) == null || _f.setZoom(17)), (_g = state.marker) == null || _g.setPosition(place.geometry.location), (_h = state.marker) == null || _h.setVisible(!0);
    },
    [state.infoWindow, state.map, state.marker]
  ), setMapPlaceRef = useRef(setMapPlace);
  return setMapPlaceRef.current = setMapPlace, useLayoutEffect(() => {
    if (googlePlace && state.map) {
      setMapPlaceRef.current(googlePlace);
      const { formattedAddress, streetAddress } = getAddressInfo(googlePlace) ?? "";
      setTooltipInfo({
        info: formattedAddress,
        header: streetAddress ?? formattedAddress.split(",")[0] ?? ""
      });
    }
  }, [state.map, googlePlace]), {
    mapRef: ref,
    tooltipRef: refInfoWindow,
    tooltip,
    setMapPlace,
    reset: () => {
      var _a, _b, _c, _d;
      (_a = state.map) == null || _a.setCenter(defaultCoords), (_b = state.map) == null || _b.setZoom(4), (_c = state.infoWindow) == null || _c.close(), refInfoWindow.current && (refInfoWindow.current.style.display = "none"), (_d = state.marker) == null || _d.setVisible(!1);
    },
    ...state
  };
};
export {
  useGoogleMap
};
//# sourceMappingURL=useGoogleMap.js.map
